import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutTypes } from '@models/layout/layout-types.enum';
import { SiteSection } from '@models/layout/site-section';

import { LayoutInstitutionalComponent }  from '@layout/layout-institutional/layout-institutional.component';
import { ForSchoolsComponent }           from './for-schools/for-schools.component';
import { HomeComponent }                 from './home/home.component';
import { AboutComponent }                from './about/about.component';
import { ContactComponent }              from './contact/contact.component';
import { TermsOfServiceComponent }       from './terms-of-service/terms-of-service.component';
import { PrivacyComponent }              from './privacy/privacy.component';
import { MarathonRegulationComponent }   from './marathon-regulation/marathon-regulation.component';
import { NewGridAnnouncementComponent }  from './new-grid-announcement/new-grid-announcement.component';
import { TutorialsComponent }            from './tutorials/tutorials.component';
import { ProofreaderApplicantComponent } from './proofreader-candidate/proofreader-applicant.component';


const routes: Routes = [
  {
    path: '',
    component: LayoutInstitutionalComponent,
    children: [
      {
        path: '', component: HomeComponent,
        data: {
          layout:    LayoutTypes.INSTITUTIONAL,
          section:   SiteSection.INSTITUTIONAL_B2C,
          animation: 'home-students'
        }
      },
      {
        path: 'para-escolas', component: ForSchoolsComponent,
        data: {
          layout:    LayoutTypes.INSTITUTIONAL,
          section:   SiteSection.INSTITUTIONAL_B2B,
          animation: 'home-schools'
        }
      },
      {
        path: 'sobre', component: AboutComponent,
        data: {
          layout:    LayoutTypes.INSTITUTIONAL,
          section:   SiteSection.ABOUT,
          animation: 'about'
        }
      },
      {
        path:      'termos-de-uso',
        component: TermsOfServiceComponent,
        data: {
          layout:    LayoutTypes.INSTITUTIONAL,
          section:   SiteSection.ABOUT,
          animation: 'about'
        }
      },
      {
        path:      'politica-de-privacidade',
        component: PrivacyComponent,
        data: {
          layout:    LayoutTypes.INSTITUTIONAL,
          section:   SiteSection.ABOUT,
          animation: 'about'
        }
      },
      {
        path:      'regulamento-maratona',
        component: MarathonRegulationComponent,
        data: {
          layout:    LayoutTypes.INSTITUTIONAL,
          section:   SiteSection.ABOUT,
          animation: 'about'
        }
      },
      {
        path:      'nova-grade',
        component: NewGridAnnouncementComponent,
        data: {
          layout:    LayoutTypes.INSTITUTIONAL,
          section:   SiteSection.ABOUT,
          animation: 'about'
        }
      },
      {
        path:      'registro-candidato',
        component: ProofreaderApplicantComponent,
        data:      {
          layout:  LayoutTypes.INSTITUTIONAL,
          section: SiteSection.REGISTER_CANDIDATE
        }
      },
      {
        path: 'tutoriais', component: TutorialsComponent,
        data: {
          layout:    LayoutTypes.INSTITUTIONAL,
          section:   SiteSection.TUTORIALS,
          animation: 'home-schools'
        }
      },
      {
        path: 'contato', component: ContactComponent,
        data: {
          layout:    LayoutTypes.INSTITUTIONAL,
          section:   SiteSection.CONTACT,
          animation: 'contact'
        }
      }
    ]
  }
];

@NgModule({
  imports: [ RouterModule.forChild(routes) ],
  exports: [ RouterModule ]
})
export class InstitutionalRoutingModule {}
